<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新增</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{  }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>

      <template slot="logoSlot" slot-scope="text, record, index">
          <span><img onclick="window.open(this.src)" v-show="record.logo !=null && record.logo != ''" :src="config.imgApiUrl + record.logo" width="60" /> </span>
      </template>
      <template slot="loginBgSlot" slot-scope="text, record, index">
        <span><img onclick="window.open(this.src)" v-show="record.logo !=null && record.logo != ''" :src="config.imgApiUrl + record.loginBg" width="60" /> </span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
<!--         <a-divider type="vertical" v-show="roleId === config.RoleType.ADMIN"/>
        <a @click="handleDel(record)" v-show="roleId === config.RoleType.ADMIN">删除</a> -->
      </span>
    </s-table>

    <a-modal
    title="操作"
    style="top: 40px;"
    :width="640"
    v-model="visible"
    @ok="handleOk"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">

      <a-form-item
        label="企业编码"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-input placeholder="公司编码" v-model="mdl.unitcode"/>
      </a-form-item>

      <a-form-item
        label="企业名称"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-input placeholder="公司名称" v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入公司名称'}]}]"/>
      </a-form-item>

      <a-form-item
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        label="咨询电话"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-input placeholder="咨询电话" v-model="mdl.phone"/>
      </a-form-item>

      <a-form-item
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        label="技术支持"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-input placeholder="技术支持" v-model="mdl.support"/>
      </a-form-item>

      <a-form-item
        label="备案号"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-input placeholder="备案号" v-model="mdl.icpNumber"/>
      </a-form-item>

      <a-form-item
        label="备案号链接地址"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >

      <a-input defaultValue=""  v-model="mdl.icpUrl">
        <a-select slot="addonBefore" defaultValue="Http://" style="width: 90px" v-model="mdl.beforeUrl">
          <a-select-option value="Http://">http://</a-select-option>
          <a-select-option value="Https://">https://</a-select-option>
        </a-select>
        <a-select slot="addonAfter" defaultValue=".com" style="width: 80px"  v-model="mdl.afterUrl">
          <a-select-option value=".com">.com</a-select-option>
          <a-select-option value=".jp">.jp</a-select-option>
          <a-select-option value=".cn">.cn</a-select-option>
          <a-select-option value=".org">.org</a-select-option>
          <a-select-option value=".net">.net</a-select-option>
          <a-select-option value=".edu">.edu</a-select-option>
        </a-select>
      </a-input>
      <!--   <a-input placeholder="备案号链接地址" v-model="mdl.support"/> -->
      </a-form-item>
      
      <a-form-item
          label="维护人"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
        <a-select
          v-model="mdl.userId"
          placeholder="请选择"
          >
          <a-select-option value="">请选择</a-select-option>
          <a-select-option v-for="(item, index) in userSelect" :key="index" :value="item.id">{{ item.username }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
          label="企业logo"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-upload
            name="file" 
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            :action= "config.uploadUrl"
            :data="param"
            :beforeUpload="beforeUpload"
            @change="handleChange"
            v-decorator="['logo', { initialValue: mdl.logo, rules: [{ required: true, message: '请上传logo图片'}]}]"
          >
            <img v-if="imageUrl" :src="imageUrl" alt="" width="400px"/>
            <div v-else>
                <a-icon :type="imageLoading ? 'imageLoading' : 'plus'" />
                <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
          <div>
              <a-icon type='exclamation-circle' /> 提示：图片格式jpg或者png，大小2兆以内，建议尺寸160*60
          </div>
        </a-form-item>

        <a-form-item
        label="登录页背景图"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-upload
          name="file" 
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          :action= "config.uploadUrl"
          :data="param"
          :beforeUpload="beforeUpload"
          @change="handleChange2"
          v-decorator="['loginBg', { initialValue: mdl.loginBg, rules: [{ required: true, message: '请上传登录页背景图图片'}]}]"
        >
          <img v-if="loginBgUrl" :src="loginBgUrl" alt="" width="400px"/>
          <div v-else>
              <a-icon :type="imageLoading ? 'imageLoading' : 'plus'" />
              <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
        <div>
            <a-icon type='exclamation-circle' /> 提示：图片格式jpg或者png，大小2兆以内，建议尺寸1900*300
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { corpCompanyPage, corpCompanySave, corpCompanyDelete } from '@/api/basic'
  import { userList } from '@/api/sys'
  import { formatDate } from '@/utils/date'

  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'CorpCompany',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        mdl: {},
        roleId: null,
        logoId: null,
        loginBgId: null,
        queryParam: {},
        loading:false,

        imageLoading: false,
        imageUrl: '',
        loginBgUrl: '',
        userSelect: [],
        param: {"url": "logo"},   // 上传目录
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '企业编码',
            dataIndex: 'unitcode'
          },
          {
            title: '企业名称',
            dataIndex: 'name',
          },
          {
            title: '咨询电话',
            dataIndex: 'phone',
          },
          {
            title: '技术支持',
            dataIndex: 'support',
          },
          {
            title: '企业logo',
            dataIndex: 'logo',
            scopedSlots: { customRender: 'logoSlot' }
          },
          {
            title: '登录页背景图',
            dataIndex: 'loginBg',
            scopedSlots: { customRender: 'loginBgSlot' }
          },
          {
            title: '创建时间',
            sorter: true,
            dataIndex: 'createTime',
            customRender: (text) => {
              const date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            width: '50px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return corpCompanyPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },
      }
    },

    created () {
      this.roleId = this.$store.getters.roles
      this.loadUserSelect()
    },
    methods: {
      loadUserSelect () { 
        new Promise(resolve => {
          const data = userList({ }).then(res => { 
            return res.data 
          })
          resolve(data)
        }).then(res => {
          this.userSelect = res
        })
      },
      handleAdd () {
        this.mdl = {}
        this.mdl.beforeUrl =  "http://"
        this.mdl.afterUrl = ".com"
        this.imageUrl = ''
        this.loginBgUrl = ''
        this.logo = null
        this.loginBg = null
        this.form = this.$form.createForm(this)
        this.visible = true
      },

      handleEdit (record) {
        this.mdl = Object.assign({}, record)
        this.form = this.$form.createForm(this)
        this.visible = true
        if (record.logo){
          this.imageUrl = this.config.imgApiUrl + record.logo
          this.logoId = record.logo
        }
        if (record.loginBg){
          this.loginBgUrl = this.config.imgApiUrl + record.loginBg
          this.loginBgId = record.loginBg
        }
        if (record.icpUrl){
          this.mdl.beforeUrl = record.icpUrl.substring(0, record.icpUrl.indexOf('//')+2);
          this.mdl.icpUrl = record.icpUrl.substring(record.icpUrl.indexOf('//')+2, record.icpUrl.lastIndexOf('.'));
          this.mdl.afterUrl = record.icpUrl.substring(record.icpUrl.lastIndexOf('.')+1);
        }else{
          this.mdl.beforeUrl =  "http://"
          this.mdl.afterUrl = ".com"
        }
      },

      handleOk () {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            if (!this.logoId){
              this.$message.warning('请上传logo图片',2)
              return
            }
            if (!this.loginBgId){
              this.$message.warning('请上传登录页背景图片',2)
              return
            }
            this.mdl.logo = this.logoId
            this.mdl.loginBg = this.loginBgId
            this.mdl.name = values.name
            if (this.mdl.icpUrl){
              this.mdl.icpUrl = this.mdl.beforeUrl + this.mdl.icpUrl + this.mdl.afterUrl
            }
            corpCompanySave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.visible = false
                  this.$form.createForm(this)
                  this.$refs.table.refresh()
                }
              }).catch((da) => {
               console.log(da)
              }).finally((res) => {
                this.confirmLoading = false
              })
          }
        })
      },

      handleDel (record) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            return corpCompanyDelete(Object.assign(record, that.queryParam))
              .then(res => {
                if (res.code === '0') {
                  that.$refs.table.refresh()
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
              })
          },
          onCancel () {
          }
        })
      },

      handleChange (info) {
        if (info.file.status === 'uploading') {
          this.imageLoading = true
          return
        }

        if (info.file.status === 'done') {
          if (info.file.response && info.file.response.code === '0'){
              this.logoId = info.file.response.data.id;
              getBase64(info.file.originFileObj, (imageUrl) => {
                this.imageUrl = imageUrl
                this.imageLoading = false
            })
          }
        }
      },

      handleChange2 (info) {
        if (info.file.status === 'uploading') {
          this.imageLoading = true
          return
        }

        if (info.file.status === 'done') {
          if (info.file.response && info.file.response.code === '0'){
              this.loginBgId = info.file.response.data.id;
              getBase64(info.file.originFileObj, (imageUrl) => {
                this.loginBgUrl = imageUrl
                this.imageLoading = false
            })
          }
        }
      },
      beforeUpload (file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png')
        if (!isJPG) {
          this.$message.error('请选择jpg或者png格式的图片上传!')
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('请选择小于2M的图片上传!')
        }
        return isJPG && isLt2M 
      /*   const isLt200K = file.size / 1024  < 200
        if (!isLt200K) {
          this.$message.error('请选择小于200k的图片上传!')
        }
        return isJPG && isLt200K */
      },
    },

  }

</script>


</script>
<style>
  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>